import { footerConstants as fc } from 'srcReact/Footer'

export function footer(state = {}, action) {
  switch (action.type) {
    // susbcribe newsletter
    case fc.SUBSCRIBE_NEWSLETTER_REQUEST:
      return {
        newsletter: {
          submitted: true,
          success: false,
        },
      }
    case fc.SUBSCRIBE_NEWSLETTER_SUCCESS:
      return {
        ...state,
        newsletter: {
          submitted: false,
          success: true,
        },
      }

    // failures
    case fc.SUBSCRIBE_NEWSLETTER_FAILURE:
      return {
        ...state,
        newsletter: {
          submitted: false,
          error: true,
          success: false,
        },
      }
    default:
      return state
  }
}
